AGADash.Charts = (function () {

    var legendPositions = {
        "N": null,
        "E": "left",
        "A": "top",
        "D": "right",
        "B": "bottom"
    };

    var legendKinds = ["", "[[value]]", "[[percents]]%"];

    var labelKinds = ["",
            "[[title]]: [[value]]([[percents]]%)",
            "[[title]]: [[value]]",
            "[[title]]: [[percents]]%",
            "[[value]]",
            "[[percents]]%"];

    return {
        getLegend: function (data) {
            var pos = legendPositions[data.LegendPosition];

            var legend = {
                "position": pos,
                "autoMargins": true,
                "labelText": "[[title]]"
            };

            if (data.LegendKind >= 1 && data.LegendKind <= 3)
                legend["valueText"] = legendKinds[data.LegendKind];

            return legend;
        },

        getLabelText: function (data) {
            var kind = labelKinds[data.LabelKind];
            if (kind)
                return kind;
            return "";
        },

        getExportSettings: function () {

            var exportPdf = {
                "format": "PDF",
                "content": ["Salvo de:", window.location.href, {
                    "image": "reference",
                    "fit": [523.28, 769.89] // fit image to A4
                }]
            };

            /**
             * Print-specfic configuration
             */
            var exportPrint = {
                "format": "PRINT",
                "label": "Imprimir"
            };

            var config = {
                "enabled": true,
                "libs": {
                    "path": AGADash.appUrl() + 'Content/assets/amcharts/plugins/export/libs/'
                },
                "menu": [{
                    "class": "export-main",
                    "label": "Exportar",
                    "menu": [{
                        "label": "Download como ...",
                        "menu": ["PNG", "JPG", "SVG", exportPdf]
                    }, {
                        "label": "Salvar dados ...",
                        "menu": ["CSV", "XLSX", "JSON"]
                    }, {
                        "label": "Anotações",
                        "action": "draw",
                        "menu": [{
                            "class": "export-drawing",
                            "menu": [{
                                "label": "Cor ...",
                                "menu": [{
                                    "class": "export-drawing-color export-drawing-color-black",
                                    "label": "Black",
                                    "click": function () {
                                        this.setup.fabric.freeDrawingBrush.color = "#000";
                                    }
                                }, {
                                    "class": "export-drawing-color export-drawing-color-white",
                                    "label": "White",
                                    "click": function () {
                                        this.setup.fabric.freeDrawingBrush.color = "#fff";
                                    }
                                }, {
                                    "class": "export-drawing-color export-drawing-color-red",
                                    "label": "Red",
                                    "click": function () {
                                        this.setup.fabric.freeDrawingBrush.color = "#f00";
                                    }
                                }, {
                                    "class": "export-drawing-color export-drawing-color-green",
                                    "label": "Green",
                                    "click": function () {
                                        this.setup.fabric.freeDrawingBrush.color = "#0f0";
                                    }
                                }, {
                                    "class": "export-drawing-color export-drawing-color-blue",
                                    "label": "Blue",
                                    "click": function () {
                                        this.setup.fabric.freeDrawingBrush.color = "#00f";
                                    }
                                }]
                            }, "UNDO", "REDO", {
                                "label": "Salvar como ...",
                                "menu": ["PNG", "JPG", "SVG", exportPdf]
                            }, exportPrint, "CANCEL"]
                        }]
                    }, exportPrint]
                }]
            };

            return config;
        }

    };
})();
